<template>
  <div class="home" :style="page_style">
    <div class="test_tip" v-if="is_test">本页面仅供内部测试使用</div>
    <UserInfoBar v-if="show_user_info" />

    <img v-if="head_mask" :src="head_mask" class="head_mask"/>

    <van-list v-model="is_list_loading" :finished="is_list_finished" :finished-text="finished_text" @load="load_list">
      <NzmWrap
        v-for="(info) in nofloat_comps_show"
        :key="info.act_name"
        :info="info"
      >
        <component :is="info.comp_code" :info="info"></component>
      </NzmWrap>
    </van-list>

    <component
      v-for="info in float_comps"
      :key="info.act_name"
      :is="info.comp_code"
      :info="info"
    ></component>

    <ChannelChooser ref="channel_chooser" />
  </div>
</template>

<script>
// import setTitle from "../tools/set-title";
// import { page_view, casherPV } from "../tools/mgtv/analysis";
import { page_view } from "../tools/mgtv/analysis";
import { HOME_PAGE } from "../constant/analysis";
// import { setShare } from "../tools/mgtv/share";
import Vue from "vue";
import preload from "../tools/preload";
import UserInfo from "../components/ConfigUI/UserInfo.vue";
import { onUseInfoLoad } from "../tools/onUseInfoLoad";
import { towebp } from "../tools/towebp";
import ChannelChooser from "../components/Popus/ChannelChooser";
import "../components/Popus/ActAlertDialog";
import "../components/Popus/ActPhoneDialog";
import "../components/Popus/ActMcityDialog";
import "../components/Popus/Toast";
import "../components/Popus/Dialog";
import "../components/Popus/ShareDialog";
import "../components/Popus/ImgDialog";
import "../components/Popus/SubmitDialog";
import NzmWrap from "../components/ConfigUI/NzmWrap";
import NzmFlash from "../components/ConfigUI/NzmFlash";
import NzmTrailer from "../components/ConfigUI/NzmTrailer";
import NzmImgScroll from "../components/ConfigUI/NzmImgScroll";
import NzmImgMultiLine from "../components/ConfigUI/NzmImgMultiLine";

import NzmIcon from "../components/ConfigUI/NzmIcon";
import NzmActEntry from "../components/ConfigUI/NzmActEntry";
import NzmWelfareCenter from "../components/ConfigUI/NzmWelfareCenter";
import NzmMiaoSha from "../components/ConfigUI/NzmMiaosha";
import NzmFloatEntry from "../components/ConfigUI/NzmFloatEntry";

import NzmVideo from "../components/ConfigUI/NzmVideo";
import NzmBenefitRecv from "../components/ConfigUI/NzmBenefitRecv";
import NzmBenefitRecommend from "../components/ConfigUI/NzmBenefitRecommend";

import UserInfoBar from "../components/ConfigUI/UserInfoBar";
import NzmUserInfo from "../components/ConfigUI/NzmUserInfo";

import onPageShowListener from "../tools/onPageShow";
import * as Cookie from "tiny-cookie";
import { LAST_LOAD_TIME } from "../constant/CookieKeys";
import { List } from "vant";
import { bindQiyeWx, get_act_load_file } from '../api/index';
import get_param from '../tools/param';
import VueLazyload from 'vue-lazyload'
import placeholder from '../../static/placeholder.jpg'

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: placeholder,
  loading:placeholder,
  attempt: 1
})

Vue.use(List);

export default {
  name: "HomePage",
  components: {
    UserInfo,
    ChannelChooser,
    NzmWrap,
    NzmIcon,
    NzmFlash,
    NzmActEntry,
    NzmMiaoSha,
    UserInfoBar,
    NzmWelfareCenter,
    NzmImgMultiLine,
    NzmImgScroll,
    NzmFloatEntry,
    NzmVideo,
    NzmUserInfo,
    NzmTrailer,
    NzmBenefitRecommend,
    NzmBenefitRecv
  },
  data() {
    return {
      is_list_loading: false,
      is_list_finished: false,
      list_show_num:0
    };
  },
  created() {

  },
  mounted() {
    window.$channel_chooser = this.$refs.channel_chooser;
    this.save_load_time();

    setTimeout(() => {
      page_view(HOME_PAGE);
    }, 1500);

    setTimeout(() => {
      onPageShowListener.register("check_user_change", this.check_user_change);
      onPageShowListener.register("check_load_time", this.check_load_time);
      onPageShowListener.start();
      this.preload_files()
    }, 3000);

    MgtvApi && MgtvApi.registerhandler('webviewBecomeActive', {}, this.check_user_change)

    // 通过企业微信跳链过来带eid参数，自动给用户绑定企业微信信息。
    onUseInfoLoad(() => {
      window.$bus.user.ticket && get_param('eid') && bindQiyeWx(get_param('eid'))
    },true)


    //从后台回来时检查
    // setTimeout(() => {
    //   document.addEventListener("visibilitychange", () => {
    //     console.log("visibilitychange");
    //     if (!document.hidden) {
    //       console.log("show");
    //       this.check_user_change();
    //     } else {
    //       console.log("hide");
    //     }
    //   });
    // }, 3000);
  },
  computed: {
    rootdata() {
      return window.$bus.rootdata;
    },
    page() {
      return window.$bus.tpl.tpl_page;
    },
    float_comps() {
      return this.comps.filter(item => {
        return item.is_float_comp;
      });
    },
    nofloat_comps() {
      return this.comps
        .filter(item => {
          return !item.is_float_comp;
        });
    },
    nofloat_comps_show(){
      return this.nofloat_comps.slice(0, this.list_show_num).filter(item => !item.hide);
    },
    comps() {
      return window.$bus.tpl.comps;
    },
    debug() {
      return window.gact.debug;
    },
    is_test() {
      return window.gact.is_test;
    },
    show_user_info() {
      return window.gact.show_user_info;
    },
    page_style() {
      if (!this.page || !this.page.customColorBackground) {
        return {};
      }
      return { background: this.page.customColorBackground };
    },
    finished_text(){
      return this.nofloat_comps.length > 15 ? '没有更多了' : '';
    },
    head_mask(){
      if(gact.is_full_screen && !gact.hide_head_mask){
        return this.page.head_mask;
      }
      return null;
    }
  },
  methods: {
    towebp,
    check_user_change() {
      // APP中切换用户后，刷新页面。
      if (gact.is_app) {
        MgtvApi.getUserInfo(function(user_info) {
          if (user_info && user_info.length !== 0) {
            const user_info_obj = JSON.parse(user_info);
            if (window.$bus.user.uuid !== user_info_obj.uuid) {
              console.log("user changed");
              window.location.reload();
            }
          } else {
            if (window.$bus.user.uuid) {
              console.log("user changed2");
              window.location.reload();
            }
          }
        });
      }
    },
    save_load_time() {
      //上次加载时间
      const key = `${window.rootdata.act_name}_${LAST_LOAD_TIME}`;
      Cookie.set(key, new Date().getTime(), {
        expires: "7D"
      });
    },
    check_load_time() {
      //离页面加载过去30分钟以上，回来时重新加载
      const key = `${window.rootdata.act_name}_${LAST_LOAD_TIME}`;
      let last_load_time = Cookie.get(key);
      if (last_load_time) {
        last_load_time = parseInt(last_load_time);
        const delta = new Date().getTime() - last_load_time;
        console.log("from last load", delta);
        if (delta > 30 * 60 * 1000) {
          Cookie.remove(key);
          window.location.reload();
        }
      }
    },
    load_list(){
      this.is_list_loading = true;
      if(this.list_show_num === 0){
        this.list_show_num += 5;
      }else{
        this.list_show_num += 1;
      }
      this.is_list_loading = false;
        // console.log('list_load', this.list_show_num)
      if(this.list_show_num >= this.nofloat_comps.length){
        this.is_list_finished = true;
      }
    },
    preload_files() {
      get_act_load_file().then(res=>{
        if(res && res.data && res.data.list) {
          let urls = res.data.list.map(item=>item.source_url)
          preload(urls)
        }
      })
    }
  }
};
</script>
<!--
-->
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .home
    width: 7.5rem;
    position relative;
    display block;
    overflow hidden
    min-height 100vh
    padding-bottom 2rem
    .test_tip
      position fixed
      top 0
      background rgba(0,0,0,0.5)
      color #ffc448
      text-align center
      width 7.5rem
      padding .1rem 0
      font-size .26rem
      z-index 1000
      pointer-events  none
    .head_mask
      position absolute
      top 0
      left 0
      width 7.5rem
      z-index 10
    .bg
      position relative
      display block
      width 7.5rem
</style>
